import React, {Component, Fragment} from 'react'

import SettingsGroup from '../../../struct/SettingsGroup'
import Field from '../../../struct/Field'
import InputText from 'lib/struct/form/InputText'
import Select from '../../../control/DependentSelect'
import Hint from '../../../struct/Hint'

import Checkbox from "lib/control/Checkbox"

import styles from './ShopSettings.less'

const ProductsIdSelectionOptions = [{
    label: '[ID товара]',
    value: 'product_id',
}, {
    label: '[ID артикула]',
    value: 'sku_id',
}, {
    label: '[Код артикула]',
    value: 'sku_code',
}, {
    label: '[ID товара]s[ID артикула]',
    value: 'product_sku_id',
}]


export default class ShopSettings extends Component {
    constructor(props) {
        super(props)
        const enabled = props.campaign.enabled ? props.campaign.enabled : false
        const cis_enabled = props.campaign.cis_enabled ? props.campaign.cis_enabled : false
        const add_lift_price = props.campaign.add_lift_price ? props.campaign.add_lift_price : false
        const add_lift_type = props.campaign.add_lift_type ? props.campaign.add_lift_type : false
        props.campaign.ya_api_token = props.campaign.ya_api_token ? props.campaign.ya_api_token : ''
        this.state = {
            selected_products_id_option: props.campaign.selected_products_id_option,
            enabled: enabled,
	        conditions: props.context.conditions,
	        campaign: null,
            cis_enabled: cis_enabled,
            add_lift_price: add_lift_price,
            add_lift_type: add_lift_type,
            auth_method: props.campaign.auth_method
        }
    }

    changeFieldValue = (fieldName, value) => {
        this.setState({[fieldName]: value})
        this.props.campaign[fieldName] = value
    }

    componentWillMount = () => {
        this.setCampaignCondition();
    }

    componentWillReceiveProps = () => {
        this.setCampaignCondition();
    }

    changeConditions = (conditions) => {
        this.setState({conditions})
        this.props.context.conditions = conditions
        this.setCampaignCondition();
    }

    setCampaignCondition = () => {
        /** @type {CampaignSettings} */
        const campaign = this.props.campaign

        this.setState({campaign})
    }

    setActiveTab = (tab) => {
        this.changeFieldValue("auth_method", tab);
    };

    render() {
        const campaign = this.state.campaign
        const authMethod = this.state.auth_method;
        const {context, api_url, type} = this.props
        const dbs = type === 'DBS'
        const fbs = type === 'FBS'
        const fbsx = type === 'FBSX'

        return (
            <SettingsGroup title={'1. Общие настройки'} className={styles['settings-block']}>
                <Field label="Включить работу по модели">
                    <Checkbox
                        checked={this.state.enabled}
                        onChange={e => this.changeFieldValue('enabled', e.target.checked)}
                    >
                    </Checkbox>
                </Field>
                <Field label="Id кампании" required={true}>
                    <InputText
                        defaultValue={campaign.yandex_id}
                        onChange={e => campaign.yandex_id = e.target.value}
                        disabled={false}
                        readOnly={false}
                        placeholder={'213856'}
                    />
                    <Hint>
                        Чтобы узнать идентификатор, войдите в личный кабинет, нажмите на название магазина и скопируйте
                        из поля Кампания № число после дефиса. Например, если указано значение «11-213856», то
                        идентификатор кампании — 213856.
                    </Hint>
                </Field>
                <Field label="Входящий API токен" required={true}>
                    <InputText
                        defaultValue={campaign.auth_token}
                        onChange={e => campaign.auth_token = e.target.value}
                        disabled={false}
                        readOnly={false}
                        placeholder={'A9999999B999C999'}
                    />
                    <Hint>Укажите авторизационный токен, сгенерированный на странице «Настройки - Настройки API» в
                        личном кабинете <a target="_blank"
                                           href=" https://partner.market.yandex.ru/">«Яндекс.Маркета»</a></Hint>
                </Field>

                <div className={styles.settingsBlock__authTabs}>
                    <ul className="tabs">
                        {[
                            { key: "api_key", label: "Настройки авторизации API (ApiKey)" },
                            { key: "oauth", label: "(устарело) Настройки авторизации (OAuth)" }
                        ].map(({ key, label }) => (
                            <li
                                key={key}
                                onClick={() => this.setActiveTab(key)}
                                className={authMethod === key && "selected"}
                            >
                                <a>{label}</a>
                            </li>
                        ))}
                    </ul>
                </div>

                {authMethod === "api_key" && (
                    <Field label="ApiKey для запросов в Маркет" required={true}>
                        <InputText
                            defaultValue={campaign.api_key}
                            onChange={e => campaign.api_key = e.target.value}
                            disabled={false}
                            readOnly={false}
                            placeholder={'A9999999B999C999'}
                        />
                        <Hint>Укажите авторизационный токен, сгенерированный на странице «Настройки - Настройки API» в
                            личном кабинете <a target="_blank"
                                               href=" https://partner.market.yandex.ru/">«Яндекс.Маркета»</a></Hint>
                    </Field>
                )}

                {authMethod === "oauth" && (
                    <Fragment>
                        <Field label="Исходящий API токен" required={true}>
                            <InputText
                                defaultValue={campaign.ya_api_token}
                                onChange={e => campaign.ya_api_token = e.target.value}
                                disabled={false}
                                readOnly={false}
                                placeholder={'A9999999B999C999'}
                            />
                            <Hint>
                                Токен используется для авторизации исходящих запросов в Яндекс.Маркет. Для получения перейдите по{' '}
                                <a className={styles['link']}
                                   href="https://oauth.yandex.ru/authorize?response_type=token&client_id=490e75a79d104cec91de0013cd5ad778"
                                   target="_blank">ссылке</a>, подтвердите права и введите токен в это поле.{' '}
                                Вы должны быть авторизованы в аккаунте Яндекса, на котором находится ваш магазин.
                            </Hint>
                        </Field>
                    </Fragment>
                )}

                <Field label="URL API">
                    <InputText
                        defaultValue={api_url}
                        onClick={(e) => {
                            e.target.select()
                        }}
                        disabled={false}
                        readOnly={true}
                        placeholder={''}
                        style={{color: '#777777', backgroundColor: '#eeeeee', border: '1px solid #eeeeee', width:'100%'}}
                    />
                    <Hint>Скопируйте этот адрес и укажите его на странице «Настройки - Настройки API» в личном
                        кабинете <a target="_blank"
                                    href=" https://partner.market.yandex.ru/">«Яндекс.Маркета»</a></Hint>
                </Field>

                <Field label="ID для сопоставления товаров" fieldClass={styles['select-field-box']}>
                    <Select
                        options={ProductsIdSelectionOptions}
                        value={this.state.selected_products_id_option}
                        onChange={e => this.changeFieldValue('selected_products_id_option', e.target.value)}
                        state={context.form_state}
                    />
                    <Hint>{'Выберите значение, которое вы используете в качестве артикула SKU (offer-id)'}</Hint>
                </Field>
                <Field label="Формат SKU">
                    <InputText
                        defaultValue={campaign.sku_format}
                        onChange={e => campaign.sku_format = e.target.value}
                        disabled={false}
                        readOnly={false}
                        placeholder={'{$offer.id}'}
                    />
                    <Hint>
                        {"{$offer.id}"} будет заменен на фактический номер. Не удаляйте фрагмент {"{$offer.id}"} из этой строки
                    </Hint>
                </Field>
                {(dbs &&  <Field label="Добавить способ подъема на этаж в комментарий:" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                    <Checkbox
                        checked={this.state.add_lift_type}
                        onChange={e => this.changeFieldValue('add_lift_type', e.target.checked)}
                    >
                    </Checkbox>
                </Field>)}
                {(dbs &&  <Field label="Прибавлять стоимость подъема на этаж к стоимости доставки:" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                    <Checkbox
                        checked={this.state.add_lift_price}
                        onChange={e => this.changeFieldValue('add_lift_price', e.target.checked)}
                    >
                    </Checkbox>
                </Field>)}
                <Field label={'Нужно передавать коды маркировки "Честный знак":'} className={styles['select-field']} fieldClass={styles['select-field-box']}>
                    <Checkbox
                        checked={this.state.cis_enabled}
                        onChange={e => this.changeFieldValue('cis_enabled', e.target.checked)}
                    >
                    </Checkbox>
                </Field>
            </SettingsGroup>
        )
    }
}
